import { CombinedError } from "urql";

export type PatternGraphQLErrorCode =
  | "internal_error"
  | "not_found"
  | "too_busy"
  | "illegal_operation"
  | "already_exists"
  | "unauthorized"
  | "forbidden"
  | "data_violation";

export class PatternGraphQLError extends Error {
  error: {
    httpCode: number;
    errorCode: PatternGraphQLErrorCode;
    errorMessage: string;
  };
  get errorCode(): PatternGraphQLErrorCode {
    return this.error.errorCode;
  }
  get errorMessage(): string {
    return this.error.errorMessage;
  }

  constructor(message: string) {
    super(message);
    const parsed = JSON.parse(message) as PatternGraphQLError["error"];
    this.name = "PatternGraphQLError";
    this.error = parsed;
  }
}

export type ExtractedGQLError = {
  status: number;
  message: string;
};
export function extractGQLError(e: any): ExtractedGQLError | undefined {
  if (e?.name === "CombinedError") {
    const combinedError = e as CombinedError;
    const firstError = combinedError.graphQLErrors[0];
    const message = firstError?.message ?? combinedError.networkError?.message ?? combinedError.message;
    const status = (firstError?.extensions?.httpCode as number) ?? combinedError.response?.status;
    return {
      status,
      message,
    };
  } else {
    return undefined;
  }
}
